import React from "react";
import { useLocale, useFeatureFlag } from "../next/hooks";
import { useNav } from "../hooks/useNav";
import { getCoreTranslationsFor, getRegionFromUrl } from "../i18n";
import { useAlerts } from "@granular/gds-ux-components";

const tosKey = "TOS-ack";
const isAcknowledged = () => localStorage.getItem(tosKey);
const setIsAcknowledged = () => {
  localStorage.setItem(tosKey, `{ "tick": "${new Date().getTime()}" }`);
};

const Component: React.FC = () => {
  const locale = useLocale();
  const alertCtx = React.useRef(useAlerts());
  const flagForTermsOfService = useFeatureFlag({
    app: "fabric",
    key: "terms-of-service",
  });
  const isNavVisible = useNav();

  const termsOfServiceUrl = React.useCallback((): string => {
    const region = getRegionFromUrl();
    if (region === "br") {
      return "https://br.granular.ag/termos-de-servico/";
    }
    if (region === "ca") {
      if (locale.startsWith("fr")) {
        return "https://ca.granular.ag/fr/conditions-dutilisation/";
      } else {
        return "https://ca.granular.ag/terms/";
      }
    }

    return "https://granular.ag/terms/";
  }, [locale]);

  React.useEffect(() => {
    if (flagForTermsOfService && !isAcknowledged() && isNavVisible) {
      const myAlert = alertCtx.current.global.info(
        <>
          {getCoreTranslationsFor(locale).updated_terms_of_service}{" "}
          {/* rome-ignore lint/a11y/useValidAnchor: TODO fix this later */}
          <a
            href={termsOfServiceUrl()}
            target="_blank"
            onClick={() => {
              setIsAcknowledged();
              myAlert.dismiss();
            }}
            rel="noreferrer"
          >
            {getCoreTranslationsFor(locale).updated_terms_of_service_link}
          </a>
        </>,
        {
          "data-qa": "terms-of-service",
          onDismiss: setIsAcknowledged,
        },
      );
    }
  }, [
    locale,
    alertCtx,
    flagForTermsOfService,
    termsOfServiceUrl,
    isNavVisible,
  ]);

  return null;
};

export default Component;
